import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_TRANSACTION_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetMedicationRefillResult,
  GetRecentMedicationRefillPayload,
} from '../types/getRecentMedicationRefill.fromApi.types';

export const getRecentMedicationRefill = (builder: BuilderType) =>
  builder.query<GetMedicationRefillResult, GetRecentMedicationRefillPayload>({
    query: (payload: GetRecentMedicationRefillPayload) => ({
      data: payload,
      method: 'POST',
      url: GET_MEDREFILL_TRANSACTION_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetMedicationRefillResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
